import axios from "axios";
import api from "./api";

const recipientEndpoint = `/api/v1/recipient`;

export async function updateRecipient(recipientId, body, params) {
  const { data } = await api.patch(
    `${recipientEndpoint}/${recipientId}`,
    body,
    { params }
  );
  return data;
}

export async function addRecipient(recipient, params) {
  const { data } = await api.post(recipientEndpoint, recipient, { params });
  return data;
}

export async function deleteRecipient(recipientId, params) {
  const { data } = await api.delete(`${recipientEndpoint}/${recipientId}`);
  return data;
}

export async function uploadFileToS3(
  file,
  recipientListId,
  paid,
  divisionId,
  companyId,
  userId
) {
  const formData = new FormData();
  formData.append("file", file);

  const params = {
    recipientListId,
    paid,
    divisionId,
    companyId,
    userId,
  };
  
  const url = `${recipientEndpoint}/upload-recipients`;
  const { data } = await axios.post(url, formData, { params });
  return data;
}
